const BANNER_URL = 'https://storage.i-win.io/companies/105eb5de-d4de-4222-b464-f8256f90820f/banner.png'
const NOTIFICATION_FROM = 'Thungela PM Notification <noreply@winwinza.com>'

const escapeHtml = (value) => value
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')

const linkify = (value) => value.replace(
  /(https?:\/\/[^\s<]+)/g,
  '<a href="$1">$1</a>'
)

export const applyEmailTemplate = (template, { name, firstName, lastName }) => {
  return template
    .replace(/\{\{\s*name\s*\}\}/gi, name)
    .replace(/\{\{\s*firstName\s*\}\}/gi, firstName)
    .replace(/\{\{\s*lastName\s*\}\}/gi, lastName)
}

export const textToNotificationHtml = (text) => {
  return text
    .split('\n')
    .map((line) => `<p>${linkify(escapeHtml(line)) || '&nbsp;'}</p>`)
    .join('')
}

export const wrapNotificationHtml = (bodyHtml) => (
  `<div style='padding: 20px; background-color; font-family: Arial, Helvetica, sans-serif;: rgb(247, 247, 247);border-radius:10px;max-width:640px;margin:0 auto;'><img src='${BANNER_URL}' style='width:100%;object-fit:cover;max-height:150px;border-radius:10px;' />${bodyHtml}</div>`
)

export const buildNotificationPayload = ({ email, firstName, lastName, subject, bodyTemplate }) => {
  const name = [firstName, lastName].filter(Boolean).join(' ').trim() || 'Colleague'
  const text = applyEmailTemplate(bodyTemplate, { name, firstName, lastName })
  const html = wrapNotificationHtml(textToNotificationHtml(text))

  return {
    to: [email],
    from: NOTIFICATION_FROM,
    message: {
      subject,
      text,
      html
    }
  }
}
